
/**
 * 강의 난이도
 */
export type RoadmapDetailCoursesItemLevel = typeof RoadmapDetailCoursesItemLevel[keyof typeof RoadmapDetailCoursesItemLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoadmapDetailCoursesItemLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
